<script context="module" lang="ts">
    import { cx } from '$lib/utils/cx';

    export const defaultButtonClass = cx(
        'btn-leo btn-leo-toolbar-gray',
        'flex items-center justify-center gap-[6px]',
        'text-11/[120%] text-gray-650 font-bold',
        'cursor-pointer',
        'py-[6px] px-[12px]',
        'rounded-full',
    );
    export const defaultIconClass = 'text-16';
</script>

<script lang="ts">
    import { melt } from '@melt-ui/svelte';
    import { type MeltWithAction, meltWithActionDefault } from '$lib/utils/melt';

    export let type: 'button' | 'submit' = 'button';
    export let icon = '';
    export let text = '';
    export let ariaLabel: string | undefined = undefined;
    export let meltElement: MeltWithAction = meltWithActionDefault;

    export let onClick: () => void = () => {};
</script>

<button
    use:melt={meltElement}
    aria-label={ariaLabel}
    {type}
    on:click|preventDefault={onClick}
    class={defaultButtonClass}
>
    <slot>
        <i class={cx(defaultIconClass, icon)} aria-hidden={true} />
        {text}
    </slot>
</button>
